import Styled from 'styled-components'
import Media from 'styled-media-query'

export default Styled.div`
  min-width: 0;
  width: calc(100% * ${props => (props.small || 24) / 24});
  padding: 1.5rem;
  
  ${Media.greaterThan('medium')`
    width: calc(100% * ${props => (props.medium || props.small || 24) / 24});
  `}

  ${Media.greaterThan('large')`
    width: calc(100% * ${props => (props.large || props.medium || props.small || 24) / 24});
  `}

  ${Media.greaterThan('huge')`
    width: calc(100% * ${props => (props.huge || props.large || props.medium || props.small || 24) / 24});
  `}

  ${props => props.compact && `
    padding: 0.75rem;
  `}
`



// WEBPACK FOOTER //
// ./src/components/Column/index.js